import React from "react";

import tw, { css } from "twin.macro";

const Button = ({
	bg = tw`bg-black`,
	radius = tw`rounded-full`,
	onClick,
	type = `button`,
	children,
}) => {
	return (
		<button
			css={[
				tw`py-1 px-8 cursor-pointer focus:outline-none focus:shadow-outline`,
				bg,
				radius,
			]}
			onClick={onClick}
			type={type}
		>
			{children}
		</button>
	);
};

export default Button;
